import React from 'react';
import './SelectableCardButton.css';


const SelectableCardButton = ({ icon, label, onClick, selected, disabled, centered, large, ref }) => {
    return (
        <button
            className={`selectable-card-button ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''} ${centered ? 'centered' : ''} ${large ? 'large' : ''}`}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            ref={ref}
        >
            <span className="icon">{icon}</span>
            <span className="label">{label}</span>
        </button>
    );
};

export default SelectableCardButton;